import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Button from '../Elements/Button/Button';
import Input from '../Elements/Input/Input';
import { subscribeToNewsletter } from '../../actions/checkout';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/string';
import s from './Newsletter.scss';

class Newsletter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			sent: false,
		};
	}

	submitNewsletterHandler = (e) => {
		e.preventDefault();
		const { callback } = this.props;

		this.props.subscribeToNewsletter(this.state.email)
			.then(() => {
				if (callback) callback();
				setTimeout(() => {
					this.setState({ sent: false });
				}, 5000);
				return this.setState({ email: '', sent: true });
			})
			.catch((err) => console.log('DEBUG: err', err));
	}

	render() {
		const { setup, footer } = this.props;
		const { sent } = this.state;

		const newsletterInputChangeHandler = (id, value) => {
			this.setState({
				email: value,
			});
		};

		return (
			<div className={s.newsletter}>
				<form className={s.newsletter_form} onSubmit={this.submitNewsletterHandler}>
					<Input id="newsletterFooter" type="email" value={this.state.email} inputChange={newsletterInputChangeHandler} />
					<Button type="submit" text={translate(setup, footer.sendButton)} />
				</form>
				{
					sent ? (
						<span className={s.newsletter_thanks}><p>{ translate(setup, footer.sentThanks) }</p></span>
					) : (
						<span dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footer.emailTerms)) }} />
					)
				}
			</div>
		);
	}
}

const mapState = ({ environment }, { callback }) => ({ setup: environment.setup, footer: environment.footer, callback });

export default hot(module)(connect(mapState, { subscribeToNewsletter })(Newsletter));
